import BaseApiService from './BaseApiService';

class FinePrintApiService extends BaseApiService {
    constructor() {
        super('fine-print');
    }

    async getAll() {
        const response = await this.request({ method: 'get', url: '' });
        return response && response.finePrint ? response.finePrint : [];
    }
}

export default new FinePrintApiService();
